export interface FieldSpec {
  id: string
  label: string
  from: string[]
}

export interface GroupSpec {
  id: string
  title: string
  fields: FieldSpec[]
}

export const EXIF_GROUPS: GroupSpec[] = [
  {
    id: 'camera',
    title: 'Camera Information',
    fields: [
      { id: 'Make', label: 'Make', from: ['Make'] },
      { id: 'Model', label: 'Model', from: ['Model'] },
      { id: 'LensModel', label: 'Lens Model', from: ['LensModel'] },
      { id: 'LensMake', label: 'Lens Make', from: ['LensMake'] },
      { id: 'Serial', label: 'Serial Number', from: ['BodySerialNumber', 'CameraSerialNumber'] },
      { id: 'LensSerial', label: 'Lens Serial Number', from: ['LensSerialNumber'] },
      { id: 'InternalSerial', label: 'Internal Serial Number', from: ['ImageUniqueID'] },
      { id: 'Software', label: 'Software', from: ['Software'] },
      { id: 'Firmware', label: 'Firmware Version', from: ['FirmwareVersion', 'HostComputer'] }
    ]
  },
  {
    id: 'settings',
    title: 'Image Settings',
    fields: [
      { id: 'ExposureTime', label: 'Exposure Time', from: ['ExposureTime'] },
      { id: 'FNumber', label: 'F Number', from: ['FNumber'] },
      { id: 'ISO', label: 'ISO', from: ['ISOSpeedRatings'] },
      { id: 'FocalLength', label: 'Focal Length', from: ['FocalLength'] },
      { id: 'Flash', label: 'Flash', from: ['Flash'] },
      { id: 'WhiteBalance', label: 'White Balance', from: ['WhiteBalance'] },
      { id: 'ExposureProgram', label: 'Exposure Program', from: ['ExposureProgram'] },
      { id: 'MeteringMode', label: 'Metering Mode', from: ['MeteringMode'] }
    ]
  },
  {
    id: 'gps',
    title: 'GPS Data',
    fields: [
      { id: 'Latitude', label: 'Latitude', from: ['Latitude'] },
      { id: 'Longitude', label: 'Longitude', from: ['Longitude'] },
      { id: 'Altitude', label: 'Altitude', from: ['Altitude'] },
      { id: 'GPSDateStamp', label: 'GPS Date', from: ['GPSDateStamp'] },
      { id: 'GPSTimeStamp', label: 'GPS Time', from: ['GPSTimeStamp'] },
      { id: 'GPSMapDatum', label: 'Map Datum', from: ['GPSMapDatum'] }
    ]
  },
  {
    id: 'time',
    title: 'Date & Time',
    fields: [
      { id: 'DateTimeOriginal', label: 'Date Taken', from: ['DateTimeOriginal'] },
      { id: 'DateTime', label: 'File Date', from: ['DateTime'] },
      { id: 'DateTimeDigitized', label: 'Date Digitized', from: ['DateTimeDigitized'] },
      { id: 'OffsetTimeOriginal', label: 'UTC Offset', from: ['OffsetTimeOriginal', 'OffsetTime'] }
    ]
  },
  {
    id: 'author',
    title: 'Author & Copyright',
    fields: [
      { id: 'Artist', label: 'Artist', from: ['Artist', 'CameraOwnerName'] },
      { id: 'Copyright', label: 'Copyright', from: ['Copyright'] },
      { id: 'ImageDescription', label: 'Description', from: ['ImageDescription'] }
    ]
  },
  {
    id: 'props',
    title: 'Image Properties',
    fields: [
      { id: 'PixelXDimension', label: 'Width', from: ['PixelXDimension', 'ImageWidth'] },
      { id: 'PixelYDimension', label: 'Height', from: ['PixelYDimension', 'ImageLength'] },
      { id: 'Orientation', label: 'Orientation', from: ['Orientation'] },
      { id: 'ColorSpace', label: 'Color Space', from: ['ColorSpace'] },
      { id: 'XResolution', label: 'X Resolution', from: ['XResolution'] },
      { id: 'YResolution', label: 'Y Resolution', from: ['YResolution'] }
    ]
  },
  {
    id: 'thumb',
    title: 'Thumbnail Information',
    fields: [
      { id: 'ThumbSize', label: 'Embedded Preview', from: ['IFD1 preview'] }
    ]
  }
]

export function pickTag(tags: Record<string, string>, from: string[]): string {
  for (const key of from) {
    const value = tags[key]
    if (value) return value
  }
  return ''
}

export function leftoverTags(tags: Record<string, string>): Array<[string, string]> {
  const used = new Set(EXIF_GROUPS.flatMap((group) => group.fields.flatMap((field) => field.from)))
  return Object.entries(tags).filter(([key]) => !used.has(key))
}
